StatementsManager.HANDLERS.SurveyQuestionAnswered = StatementHandler.extend({

	handleBlockInitialized: function(e) {
		StatementHandler.prototype.handleBlockInitialized.call(this, e);

		var block = e.blockData.view;
		if(block instanceof SurveyQuestion) {
			this.listenTo(block, "onQuestionAnswered", this.handleQuestionAnswered);
		}
	},

	handleQuestionAnswered: function(e) {
		var otherOption = _.last(e.target.data.options);
		var otherSelected = _.findWhere(e.selected, {id: otherOption.id})
		if(otherSelected) {
			otherSelected.title = e.other.trim();
		}
		var items = _.pluck(e.selected, "title");

		this.addDataItem({
			questionTitle: e.target.data.title,
			questionTitleURI: encodeURI(e.target.data.id),
			questionText: e.target.data.question,
			response: items.join(StatementsManager.CMI_LIST_SEPARATOR)
		});

		this.ready();
	}
});
